import { activatePlan } from '../../../apis/plansApi';
import { message } from 'antd';

const ConfirmActivatePlan = ({ show, plan, onClose }) => {

  if (!show || !plan) return null;

  const handleActivatePlan = async (plan) => {
    try {
      await activatePlan(plan.id);
      window.location.reload();
      message.success("Plan activado exitosamente.");
    } catch (err) {
        message.error("Error al activar el plan.");
    }
  }

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirmación de activación</h5>
            <button type="button" className="close" onClick={onClose} aria-label="Close">
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body text-justify">
            <p> Esto desactivará tus planes actuales y activará el plan que seleccionaste.</p>
            <br />
            <p> Esta acción no se puede deshacer, ¿Estás segura que deseas activar tu plan de inmediato?</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-success" onClick={onClose}>
              No Activar
            </button>
            <button type="button" className="btn btn-danger" onClick={() => handleActivatePlan(plan)}>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActivatePlan;
